var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83887 13.5629C4.75187 13.5629 2.23887 11.0499 2.23887 7.96289C2.23887 4.87589 4.75187 2.36289 7.83887 2.36289C10.9259 2.36289 13.4389 4.87589 13.4389 7.96289C13.4389 11.0499 10.9259 13.5629 7.83887 13.5629ZM7.83887 0.962891C3.96787 0.962891 0.838867 4.09189 0.838867 7.96289C0.838867 11.8339 3.96787 14.9629 7.83887 14.9629C11.7099 14.9629 14.8389 11.8339 14.8389 7.96289C14.8389 4.09189 11.7099 0.962891 7.83887 0.962891ZM9.65187 5.16289L7.83887 6.97589L6.02587 5.16289L5.03887 6.14989L6.85187 7.96289L5.03887 9.77589L6.02587 10.7629L7.83887 8.94989L9.65187 10.7629L10.6389 9.77589L8.82587 7.96289L10.6389 6.14989L9.65187 5.16289Z",
    fill: "#A4A8B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossOutline);
export default __webpack_public_path__ + "static/media/cross-outline.1aca34b33736a4e5debeb405b0b2e3b2.svg";
export { ForwardRef as ReactComponent };